import { useState } from 'react';

import { SearchType } from '../config';
import { useRouteMatch } from 'react-router-dom';
import {
  CALL_RECORDINGS_ROUTE,
  RECORDINGS_ROUTE,
  SNIPPETS_ROUTE,
  TEMPLATES_ROUTE,
  WORKSPACE_FOLDER_ROUTE,
  WORKSPACE_ROUTE,
} from '../../../entities/history';
import { useSubscriptionLimits } from '../../../features/subscription/hooks';

export const useSearchType = () => {
  const isAllPages = useRouteMatch({ path: WORKSPACE_ROUTE, exact: true });
  const isFolderPage = useRouteMatch<{ sequenceNumber: string }>({
    path: WORKSPACE_FOLDER_ROUTE,
  });
  const isTemplatesPage = useRouteMatch({ path: TEMPLATES_ROUTE });
  const isSnippetsPage = useRouteMatch({ path: SNIPPETS_ROUTE });
  const isVideoRecordPage = useRouteMatch({ path: RECORDINGS_ROUTE });
  const isCallRecordPage = useRouteMatch({ path: CALL_RECORDINGS_ROUTE });

  const { snippets: allowSnippets } = useSubscriptionLimits();

  const [searchType, setSearchType] = useState<SearchType>(() => {
    if (isAllPages) {
      return 'all-pages';
    }

    if (isFolderPage) {
      return 'folder';
    }

    if (isTemplatesPage) {
      return 'template';
    }

    if (isSnippetsPage) {
      return allowSnippets ? 'snippet' : 'all-pages';
    }

    if (isVideoRecordPage) {
      return 'videoRecord';
    }

    if (isCallRecordPage) {
      return 'callRecord';
    }

    return 'all-pages';
  });

  return {
    searchType,
    setSearchType,
    canSearchInFolder: !!isFolderPage?.params.sequenceNumber,
  };
};
